export const TASK_GROUPINGS = ['status', 'none'] as const;

/** How the task list is broken up: by status group, or not at all. */
export type TaskGrouping = (typeof TASK_GROUPINGS)[number];

const STORAGE_KEY = 'hive.tasks.grouping';

export function isTaskGrouping(value: string | null): value is TaskGrouping {
  return value !== null && (TASK_GROUPINGS as readonly string[]).includes(value);
}

/**
 * Storage access is wrapped because localStorage throws rather than no-ops when
 * the browser blocks site data; a lost preference must not take the page down.
 *
 * Same shape as lib/projectView.ts, deliberately -- it is the one pattern in
 * the app for a view preference that outlives the tab.
 */
export function readStoredGrouping(): TaskGrouping {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isTaskGrouping(stored) ? stored : 'status';
  } catch {
    return 'status';
  }
}

export function storeGrouping(grouping: TaskGrouping): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, grouping);
  } catch {
    /* Preference is a nicety, not worth surfacing an error for. */
  }
}
